import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const a = "invoices";
class c extends e {
  /**
   * Retrieves a list of invoices.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/invoices`
   *
   * @param {InvoiceListParams} [invoiceListParams] - Optional query parameters to filter the invoices.
   * @returns {Promise<InvoicesData>} A promise that resolves to the list of invoices.
   */
  getInvoices = async (t) => {
    const { data: s } = await this.get(`${a}`, t);
    return s;
  };
  /**
   * Downloads an invoice.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/invoices/{id}/download`
   *
   * @param {string} invoiceId - The ID of the invoice to download.
   * @returns {Promise<DownloadListResponse>} A promise that resolves to the invoice download URL.
   */
  downloadInvoice = async (t) => {
    const { data: s } = await this.get(
      `${a}/${t}/download`
    );
    return s;
  };
}
export {
  c as Invoice,
  a as RESOURCE_URI
};
